export const CURRENT_OVERLAY: string = 'showInvoiceKpiModal';

const get = (): string => {
  try {
    return window.localStorage.getItem(CURRENT_OVERLAY) as string;
  } catch (error) {
    return '' as string;
  }
};

const set = (value: string) =>
  window.localStorage.setItem(CURRENT_OVERLAY, value);

const clear = () => window.localStorage.removeItem(CURRENT_OVERLAY);

const OverLayStorage = {
  get,
  set,
  clear,
};

export default OverLayStorage;
